import { PkCarousel, PkDivider } from '@uefadigital/panenka-react';
import parseHtmlToReact from 'html-react-parser';
import { lazy, memo, useMemo, useState } from 'react';

import Card from '../Card';
import useAttributeChange from '../hooks';

import ErrorBoundary from '@shared/ErrorBoundary';
import { useEventbus } from '@shared/hooks/useEventbus';
import type { Match } from '@shared-types/match.types';

const StoryWidget = lazy(() => import('@shared/StoryWidget'));

import * as classes from './styles.module.scss';

const breakpoints = {
  0: {
    slidesPerView: 'auto',
    spaceBetween: 12,
  },
  768: {
    slidesPerView: 'auto',
    slidesPerGroup: 3,
    spaceBetween: 12,
  },
  1200: {
    slidesPerView: 'auto',
    slidesPerGroup: 4,
    spaceBetween: 12,
  },
};

const emptyData = [];

const NotLiveComponent = ({ data = emptyData, title = '', match }: { data: any; title: string; match: Match }) => {
  const variant = useAttributeChange('.js-match-content', 'data-ab-test-variant');

  const [hasError, setHasError] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleStoryError = () => {
    setHasError(true);
  };

  useEventbus(() => {
    setRefreshKey((prevKey) => prevKey + 1);
  }, 'ab-refresh');

  const dataKey = useMemo(
    () =>
      data
        ?.filter((item) => !item.hide)
        ?.map((item) => item?.mainMedia?.headline)
        ?.join('-'),
    [data],
  );

  const carouselKey = useMemo(() => {
    return `${refreshKey}-${!hasError && variant === 'B' ? 1 : 0}-${dataKey}`;
  }, [refreshKey, hasError, variant, dataKey]);

  return (
    <ErrorBoundary>
      <div className={classes.carousel}>
        <PkCarousel key={carouselKey} breakpoints={JSON.stringify(breakpoints)}>
          <div className={classes.carousel__title} slot='headline'>
            {parseHtmlToReact(title ?? '')}
          </div>
          {!hasError && variant === 'B' && (
            <StoryWidget
              categories={[match.id]}
              onError={handleStoryError}
              disablePopover
              seasonYear={match.seasonYear}
              showLiveChip
              showTitle
              height={145}
              width={125}
              fontSizeDesktop={9}
              fontSizeMobile={9}
              liveChipFontSizeDesktop={9}
              liveChipFontSizeMobile={9}
              context={variant}
            />
          )}
          {data
            .filter((item) => !item.hide)
            .map((item) => (
              <Card key={item.id} item={item} />
            ))}
        </PkCarousel>
        <PkDivider className='divider--horizontal' direction='horizontal' />
      </div>
    </ErrorBoundary>
  );
};

export default memo(NotLiveComponent);
